import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import PhaseBanner from 'client/components/suc/PhaseBanner/PhaseBanner';
import Footer from 'client/components/suc/Footer/Footer';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Page.module.scss';

const Page = ({ children, title, role, className, ...props }) => {
    return (
        <div
            className={styles.wrapper}
            data-testid={props['data-testid'] ? props['data-testid'] : null}
        >
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <div className={styles.container} role={role}>
                <div className={styles.page}>
                    <div className="govuk-width-container">
                        <div className={['govuk-main-wrapper', className].join(' ')}>
                            <div className="govuk-grid-row">
                                <div className={['govuk-grid-column-full', styles.banner].join(' ')}>
                                    <PhaseBanner />
                                </div>
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <Footer/>
            </div>
        </div>
    );
};

Page.propTypes = {
    ...defaultAriaProps,
    title: PropTypes.string,
    role: PropTypes.string,
    className: PropTypes.string
};

Page.defaultProps = {
    role: 'main',
    title: 'NUAR',
    className: ''
};

export default Page;
